function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  --collapsed-height: ",
        ";\n  min-height: var(--collapsed-height) !important;\n  border-color: ",
        " !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  height: var(--collapsed-height) !important;\n  &.Mui-focused {\n    background-color: transparent !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import styled from 'styled-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionActions from '@material-ui/core/AccordionActions';
import _ from 'lodash';
export var AccordionContext = /*#__PURE__*/ React.createContext();
var getAccordionSize = function(prop) {
    var hasPixelValue = _.includes(prop, 'px');
    if (hasPixelValue) {
        var __split;
        var __split_;
        var value = (__split_ = (__split = _.split(prop, "px")) === null || __split === void 0 ? void 0 : __split[0]) !== null && __split_ !== void 0 ? __split_ : '';
        if (!Number.isNaN(value)) {
            return prop;
        }
    }
    return prop === 'large' ? "80px" : "54px";
};
var AccordionStyled = styled(function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(Accordion, _object_spread({}, props));
})(_templateObject(), function(param) {
    var collapsedSize = param.collapsedSize;
    return getAccordionSize(collapsedSize);
}, function(props) {
    return props.error ? "#e25241" : "var(--dcm-checkout-input-border-color, #d8dee3)";
});
var AccordionSummaryStyled = styled(AccordionSummary)(_templateObject1());
var AccordionActionsStyled = styled(AccordionActions)(_templateObject2());
// mui theme overrides
export var MuiAccordion = {
    root: {
        minHeight: '54px',
        maxWidth: 390,
        borderRadius: 5,
        border: '1px solid',
        borderColor: '#d8dee3',
        backgroundColor: 'transparent',
        boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.07)',
        '&.MuiCollapse-container': {
            marginTop: -16
        }
    }
};
export var MuiAccordionSummary = {
    root: {
        height: '54px',
        padding: '0 21px 0 21px',
        alignItems: 'center',
        transition: 'none',
        '&.Mui-expanded': {
            minHeight: '54px',
            position: 'relative'
        }
    }
};
export var MuiAccordionActions = {
    root: {
        padding: '0 21px 21px 21px'
    }
};
function AccordionWrapper(props) {
    var expanded = props.expanded, disabled = props.disabled;
    var contextValue = useMemo(function() {
        return {
            expanded: expanded,
            disabled: disabled
        };
    }, [
        expanded,
        disabled
    ]);
    return /*#__PURE__*/ _jsx(AccordionContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ _jsx(AccordionStyled, _object_spread({}, props))
    });
}
AccordionWrapper.testProps = [
    {
        children: [
            /*#__PURE__*/ _jsx(AccordionSummaryStyled, {
                children: "Summary"
            }),
            /*#__PURE__*/ _jsx(AccordionActionsStyled, {
                children: "Details"
            })
        ]
    },
    {
        children: [
            /*#__PURE__*/ _jsx(AccordionSummaryStyled, {
                children: "Summary"
            }),
            /*#__PURE__*/ _jsx(AccordionActionsStyled, {
                children: "Details"
            })
        ],
        expanded: true
    }
];
AccordionSummaryStyled.snapshot = false;
AccordionActionsStyled.snapshot = false;
export { AccordionWrapper as Accordion, AccordionSummaryStyled as AccordionSummary, AccordionActionsStyled as AccordionActions };
